/**
 * 文件路径
 * 文件类：files/模块名
 * 图片类：images/模块名
 * 视频类：videos/模块名
 * 富文本内部图片：editor/模块名
 */

export const bizPath = {
    // 用户头像
    userHead: 'images/admin/UserHead',
    // 老师头像
    teacherHead: 'images/teacher/head',
    // 老师介绍视频
    teacherIntroduction: 'videos/teacher/introduction',
    // 老师详细介绍
    teacherDetailedIntroduction: 'editor/teacher/detailedIntroduction',
    // 班型封面
    classTypeCover: 'images/ClassType/cover',
    // 班型详情大图
    classTypeDetail: 'images/ClassType/detail',
    // 班型介绍（富文本）
    classTypeIntroduce: 'editor/ClassType/introduce',
    // 班型课表信息（富文本）
    classTypeCourse: 'editor/ClassType/course',
    // 班型管理-课件
    ClassSectionCourseware: 'files/ClassSection/teachingMaterials',
    // 班型资料-资料
    ClassInformationData: 'files/ClassInformation/information',
    // 公司管理
    companyPayData: 'images/payConfig/pic',
    // 站点管理-站点Logo（网站，APP，等）
    siteLogo: 'images/site/SiteLogo',
    // 站点管理-页尾图片（网站，APP，等）
    siteFooterPic: 'images/site/SiteFooterPic',
    // 站点管理-协议内容（富文本）
    siteAgreementInfo: 'editor/site/AgreementInfo',
    // 站点管理- 协议摘要内容（富文本）
    siteAgreementSummary: 'editor/site/AgreementSummary',
    // 站点管理-站点预制支付方式图标
    sitePayMethodIcon: 'images/site/PayMethodIcon',
    // 站点管理-订金-订金支付协议内容
    depositAgreement: 'editor/site/depositAgreement',
    // 站点管理-订金-背景图或banner图
    depositPic: 'images/site/depositImage',
    // 社区管理-官方IP头像
    communityIpAvatar: 'images/community/IpAvatar',
    // 社区管理-圈子图标
    communityCircleIcon: 'images/community/CircleIcon',
    // 社区管理-圈子封面
    communityCircleCover: 'images/community/CircleCover',
    // 社区管理-文章的封面
    communityArticleCover: 'images/community/ArticleCover',
    // 社区管理-发文章的内容（富文本）
    communityArticleInfo: 'editor/community/ArticleInfo',
    // 社区管理-发文章的附件
    communityArticleEnclosure: 'files/community/ArticleEnclosure',
    // 社区管理-贴子图片
    communityPostPic: 'images/community/PostPic',
    // 社区管理-评论图片
    communityCommentPic: 'images/community/CommentPic',
    // 订单：支付截图
    orderPayWayVoucher: 'images/order/PayWayVoucher',
    // 题库-题目
    questions: 'editor/questionBank/questions',
    // 题库-考点笔记
    questionBankTestNote: 'files/questionBank/TestNote',
    // 题库-提问纠错
    questionsCorrection: 'images/questionBank/QuestionsCorrection',
    // 版本管理-APK包
    versionApk: 'files/version/apk',
    // 群发管理-新建群发图片
    massPicture: 'images/mass/pic',
    // 群发管理-新建群发文件
    massFile: 'files/mass/massFile',
    // 轮播图
    carouselFile: 'images/rotationChart',
    // 报考富文本编辑
    baoKaoEditorInfo: 'editor/baoKao/baoKaoInfo',
    // 作业要求
    homeWorkInfo: 'editor/homeWork/info'
};
